import { moment } from "@msuite/utils/date";

export function getPlaceholderString(item: { type: string }) {
	const today = moment();

	switch (item.type) {
		case "day":
			return today.format("DD").padStart(2, "0");
		case "month":
			return today.format("MM").padStart(2, "0");
		case "year":
			return today.format("YYYY").padStart(4, "0");
		case "hour":
			return "12";
		case "minute":
		case "second":
			return "00";
		default:
			return "";
	}
}
